<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="New Student" @close="close()" />

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined autofocus dense hide-details
              @change="Student.firstName = properCase(Student.firstName)" v-model="Student.firstName"
              label="First Name"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined dense hide-details @change="Student.lastName = properCase(Student.lastName)"
              v-model="Student.lastName" label="Last Name"></v-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="9">
            <v-text-field
              outlined
              :hide-details="nameErrors.length === 0"
              dense
              autofocus
              :error-messages="nameErrors"
              v-model="name"
              label="Name"
            ></v-text-field>
          </v-col> -->
          <v-col cols="12" sm="6" md="6">
            <v-select dense hide-details :items="['male', 'female']" label="Gender" v-model="Student.gender" outlined>
            </v-select>
            <!-- <v-text-field
              outlined
              :hide-details="nameErrors.length === 0"
              dense
              autofocus
              :error-messages="nameErrors"
              v-model="Student.name"
              label="Name"
            ></v-text-field> -->
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined dense v-mask="'(###) ###-####'" hide-details v-model="Student.phoneNumber"
              label="Phone Number"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined dense hide-details v-model="Student.email" label="Email Address"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-autocomplete dense hide-details :items="Classes" clearable item-text="name" v-model="selectedClass"
              return-object label="Class" outlined>
              <template slot="item" slot-scope="{ item }">
                <span>{{ item.name }}</span>
                <v-spacer></v-spacer>
                <v-chip color="grey lighten-3" small>
                  <span>{{ item.defaultFee | currency }}</span>
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-autocomplete dense hide-details :items="Teacher" clearable item-text="name" v-model="selectedTeacher"
              return-object label="Teacher" outlined></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-text-field outlined hide-details dense v-model="Student.reference" label="Reference"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col class="pa-0" cols="12" sm="12" md="6">
            <v-col cols="12" sm="12">
              <v-text-field outlined dense :background-color="`${Student.dob ? false : '#E8F5E9'}`" hide-details
                type="date" v-model="Student.dob" label="Date of Birth"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-textarea outlined dense hide-details auto-grow v-model="Student.description"
                :label="$t('labels.description')"></v-textarea>
            </v-col>
          </v-col>
          <v-col class="pa-0" cols="12" sm="12" md="6">
            <v-col cols="12" sm="12">
              <v-text-field outlined dense hide-details type="number" @focus="$event.target.select()"
                class="right-input" v-model="fee" label="Default Fee"></v-text-field>
            </v-col>

            <v-col cols="12" sm="12">
              <v-text-field outlined dense :disabled="!selectedClass" type="number" hide-details
                @focus="$event.target.select()" class="right-input" v-model="discount" label="Discount"></v-text-field>
            </v-col>

            <v-col cols="12" sm="12">
              <v-text-field outlined dense :disabled="!selectedClass" type="number" hide-details
                @focus="$event.target.select()" class="right-input" v-model="charity" label="Charity"></v-text-field>
            </v-col>

            <v-col cols="12" sm="12">
              <v-text-field readonly outlined dense hide-details type="number" @focus="$event.target.select()"
                class="right-input" v-model="parentPay" label="Parent Pay"></v-text-field>
            </v-col>
          </v-col>

          <!-- <v-col cols="12" sm="12">
            <v-textarea
              outlined
              dense
              hide-details
              auto-grow
              v-model="Student.description"
              :label="$t('labels.description')"
            ></v-textarea>
          </v-col> -->
        </v-row>
      </v-card-text>
      <v-card-text>
        <div>
          {{ Student.firstName }} fee will be {{ balancePayment | currency }} a
          month. And {{ sponsor | currency }} will be collected by sponsor.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import studentService from "@/modules/Student/service.js";
import classesService from "@/modules/Classes/service.js";
import teacherService from "@/modules/Teacher/service.js";
import GlobalFunction from "@/mixins/GlobalFunction";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-student",
  props: {
    createDialog: {
      default: false,
    },
    CustomerId: {
      default: null,
    },
    createFromStore: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      Teacher: [],
      Classes: [],
      selectedClass: null,
      selectedTeacher: null,
      dialog: false,
      Student: {
        name: null,
        email: null,
        gender: "male",
        phoneNumber: null,
        reference: null,
        note: null,
        fee: 0,
        discount: 0,
        sponsor: 0,
        parentPay: 0,
        charity: 0,
      },
      fee: 0,
      discount: 0,
      sponsor: 0,
      parentPay: 0,
      charity: 0,
    };
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    Student: {
      firstName: {
        required,
      },
    },
  },
  watch: {
    selectedClass(val) {
      console.log("val in selected ", val);
      this.fee = val.defaultFee;
      this.parentPay = val.defaultFee;
    },
    discount(val) {
      this.parentPay = this.fee - val - this.charity;
    },
    parentPay(val) {
      this.sponsor = this.fee - this.discount - val;
    },
    fee(val) {
      this.parentPay = val - this.discount - this.charity;
    },
    charity(val) {
      this.parentPay = this.fee - this.discount - val
    },
    createDialog(val) {
      this.dialog = val;
      this.getClasses();
      this.getTeacher();
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    balancePayment() {
      return this.fee - this.discount - this.sponsor;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.Student.firstName.$dirty) return errors;
      if (!this.$v.Student.firstName.required)
        errors.push("First name is required");

      return errors;
    },
  },
  methods: {
    getClasses() {
      return classesService.getAll().then((response) => {
        console.log("response", response);
        this.Classes = response.data;
        return response;
      });
    },
    getTeacher() {
      return teacherService.getAll().then((response) => {
        this.Teacher = response.data;

        // this.StudentList = this.Teacher.Students;
        return response;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Student = {
        name: null,
        email: null,
        gender: "male",
        phoneNumber: null,
        reference: null,
        note: null,
        fee: 0,
        discount: 0,
        charity: 0,
        sponsor: 0,
      };
      this.fee = 0;
      this.discount = 0;
      this.charity = 0;
      this.sponsor = 0;
      this.parentPay = 0;
      this.selectedClass = null;
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        this.Student.CustomerId = this.CustomerId;
        console.log("student", this.Student);
        if (this.selectedClass) {
          this.Student.ClassId = this.selectedClass.id;
        }
        if (this.selectedTeacher) {
          this.Student.TeacherId = this.selectedTeacher.id;
        }
        this.Student.fee = this.fee;
        this.Student.discount = this.discount;
        this.Student.charity = this.charity;
        this.Student.sponsor = this.sponsor;
        this.Student.parentPay = this.parentPay;
        return studentService
          .create(this.Student)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Student is created",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>
